export const getEmailComunication = (countryiso) => {
  switch (countryiso) {
    case "gb":
      return "press@uk.zara.com";
    case "it":
      return "press@it.zara.com";
    case "fr":
      return "press@fr.zara.com";
    case "pl":
      return "press@pl.zara.com";
    case "ru":
      return "press@ru.zara.com";
    case "de":
      return "press@de.zara.com";
    case "be":
    case "nl":
    case "lu":
      return "press@be.zara.com";
    case "gr":
      return "press@gr.zara.com";
    case "pt":
      return "press@pt.zara.com";
    case "us":
      return "press@us.zara.com";
    case "za":
      return "press@za.zara.com";
    case "mx":
      return "press@mx.zara.com";
    case "br":
      return "press@br.zara.com";
    case "jp":
      return "press@jp.zara.com";
    case "hk":
      return "press@hk.zara.com";
    case "cn":
      return "press@cn.zara.com";
    case "kr":
      return "press@kr.zara.com";
    default:
      return "press@zara.com";
  }
};
